import FulfilledByIcon from "@redotech/redo-icons/building-01.svg";
import { FulfilledBy } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { toTitleCase } from "@redotech/redo-model/views/default-outbound-views";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const FulfilledByArrayFilter: ArrayStringTableFilter<string> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: FulfilledByIcon,
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "fulfilledBy",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  itemLabel: "party",
  itemLabelPlural: "parties",
  values: Object.values(FulfilledBy).map((fulfilledBy) =>
    toTitleCase(fulfilledBy),
  ),
  displayName: "Fulfilled by",
};
